import set from 'lodash/set';
import { createReducer } from 'redux-act';
import { setBooking, fetchBookingFailure, clearBooking, showNpsSurveyAfterBooking } from './bookingActions';

const initialState = {
  error: undefined,
  booking: undefined,
};

export const reducer = createReducer(
  {
    [setBooking]: (state, booking) => ({
      ...state,
      booking,
    }),
    [clearBooking]: (state) => ({
      ...state,
      booking: null,
    }),
    [fetchBookingFailure]: (state, error) => ({ ...state, booking: null, error }),
    [showNpsSurveyAfterBooking]: (state) => set(state, 'booking.showNpsSurveyAfterBooking', true),
  },
  initialState,
);
